// extracted by mini-css-extract-plugin
module.exports = {"root":"MerchantPurposeOption_root__2AXqk","active":"MerchantPurposeOption_active__Y2lb3","iconWrapper":"MerchantPurposeOption_iconWrapper__1KHPp"};